<template>
  <v-dialog persistent v-model="dialog" max-width="500">
    <v-card v-if="email">
      <v-card-title>
        {{ titulo }}
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="email.email"
          v-touch="email.email"
          label="Email"
          :error-messages="emailErrors"
          counter="80"
        />
        <v-switch label="Email principal" v-model="email.principal" />
        <v-text-field
          v-model="email.nome"
          v-touch="email.nome"
          label="Identificação do email"
          :error-messages="nomeErrors"
          counter="40"
        />
        <v-textarea
          auto-grow
          rows="2"
          v-model="email.descricao"
          v-touch="email.descricao"
          label="Descrição"
          :error-messages="descricaoErrors"
          counter="140"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog = false">CANCELAR</v-btn>
        <v-btn
          class="primary"
          depressed
          :disabled="$v.$invalid"
          @click="salvar()"
          >{{ tituloBotao }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    email: {
      email: { required, email, maxLength: maxLength(80) },
      nome: { maxLength: maxLength(40) },
      descricao: { maxLength: maxLength(140) },
    },
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.contato.emailAtivo;
      },
      set(open) {
        if (!open) {
          this.$store.commit("contato/limparEmailAtivo");
        }
      },
    },
    titulo() {
      return this.email.id ? "Editar email" : "Novo email";
    },
    tituloBotao() {
      return this.email.id ? "Editar" : "Adicionar";
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.email.$dirty) return errors;
      !this.$v.email.email.required && errors.push("Informe o email");
      !this.$v.email.email.email && errors.push("Informe um email válido");
      !this.$v.email.email.maxLength && errors.push("Somente 80 caracteres");
      return errors;
    },
    nomeErrors() {
      const errors = [];
      if (!this.$v.email.nome.$dirty) return errors;
      !this.$v.email.nome.maxLength && errors.push("Somente 40 caracteres");
      return errors;
    },
    descricaoErrors() {
      const errors = [];
      if (!this.$v.email.descricao.$dirty) return errors;
      !this.$v.email.descricao.maxLength &&
        errors.push("Somente 140 caracteres");
      return errors;
    },
    email: {
      get() {
        return this.$store.state.contato.emailAtivo;
      },
      set(email) {
        this.$store.commit("contato/editarEmail", email);
      },
    },
  },
  methods: {
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.email.novo = this.email.novo || !this.email.id;
        this.email.editar = !this.email.novo && this.email.id !== "";
        this.$emit("change", this.email);
        this.dialog = false;
      }
    },
  },
};
</script>
